import template from '../ui/templates/modal/help.hbs';

class ModalHelp {
  constructor (opts) {
    this.opts = $.extend(
      {
        userId: INKIVE.C.USER.id,
        userName: Base64.decode(INKIVE.C.USER.nickname),
        userEmail: Base64.decode(INKIVE.C.USER.email),

        baseUrl: INKIVE.C.BASE_URL,
        staticUrl: INKIVE.C.STATIC_URL
      },
      opts
    );

    this.$wrapper = $(
      this.opts.wrapper
        ? $.parseHTML(this.opts.wrapper)
        : $.parseHTML('<div class="tool-content"></div>')
    );

    const whiteLabelConfig = INKIVE.C.WHITE_LABEL_CONFIGURATION || {};

    this.$wrapper.append(
      template({
        user_name: this.opts.userName,
        user_email: this.opts.userEmail,
        show_faq: whiteLabelConfig.subscription_plan !== 'enterprise'
      })
    );
  }

  getFormHtml () {
    return this.$wrapper;
  }

  saveForm (callback) {
    const Tool = INKIVE.Tool.getInstance();
    const params = {
      email: this.$wrapper.find('[name="email"]').val(),
      name: this.$wrapper.find('[name="name"]').val(),
      help: this.$wrapper.find('[name="help"]').val(),
      scrapbook_id: INKIVE.C.BOOK.id,
      is_webrand: INKIVE.Helpers.isWeBrandProject(),
      thumb: INKIVE.C.BOOK.thumb
    };

    const classList = $('#svgcontent g.main')[0].classList;
    const className = _.find(classList, function (className) {
      return className.indexOf('layout-id') === 0;
    });

    if (className) params.template_id = className.split('-')[2];

    INKIVE.Helpers.api('inkive/feedback', 'POST', params, function (r) {
      callback && callback(r.status);
    });
  }
}

module.exports = ModalHelp;
